import { createSlice } from '@reduxjs/toolkit';
import { mapCategories, mapSubcategories } from '../../utils/entity-utils';
import { getAllGraphDetails } from './mainContentSlice';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  categories: [],
  subcategories: [],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllGraphDetails.fulfilled, (state, action) => {
      state.categories = mapCategories(action.payload);
      state.subcategories = mapSubcategories(action.payload);
    });
  },
});

export default categoriesSlice.reducer;
